import React from 'react';

import { Typography as AntdTypo } from 'antd';

import { FilterButton } from 'components/WrappedComponents';

import { SupervisionUserEventsFilterFormValues } from '../types';

import SupervisionFilterForm from './FilterFormSupervision/SupervisionFilterForm';

interface FiltersProps {
  filter: Partial<SupervisionUserEventsFilterFormValues>;
  setFilter: (value: Partial<SupervisionUserEventsFilterFormValues>) => void;
}

function Filters({ filter, setFilter }: FiltersProps): React.ReactElement {
  const { ...formFilter } = filter;

  function setFormFilter(
    value: Partial<SupervisionUserEventsFilterFormValues>,
  ) {
    setFilter({
      ...filter,
      ...value,
    });
  }

  return (
    <div>
      <FilterButton
        filter={formFilter}
        setFilter={setFormFilter}
        textInactiveFilter="Filtres"
        textActiveFilter="Filtres (actifs)"
      >
        {(setData, data) => (
          <>
            <AntdTypo.Title level={3}>Filtres</AntdTypo.Title>
            <SupervisionFilterForm filter={data} setFilter={setData} />
          </>
        )}
      </FilterButton>
    </div>
  );
}

export default Filters;
